import React from 'react';
import { useStyles } from './Breadcrumbs.styles';
import { BreadcrumbsProps } from './Breadcrumbs.types';

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs, className }) => {
  const styles = useStyles();

  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <div className={`${styles.root} ${className ?? ''}`}>
      {breadcrumbs.map((crumb, idx) => (
        <React.Fragment key={crumb + idx}>
          <div className={`${styles.item} ${idx === breadcrumbs.length - 1 ? styles.boldItem : ''}`}>{crumb}</div>
          {idx < breadcrumbs.length - 1 && <span className={styles.separator}>/</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
